import { plural } from "../plural";

/**
 * Words used all over the app. Reach for these before adding a new key, so
 * "Cancel" is translated once and reads the same on every screen.
 */
export default {
  cancel: "Cancel",
  save: "Save",
  saving: "Saving…",
  saved: "Saved",
  delete: "Delete",
  deleting: "Deleting…",
  remove: "Remove",
  close: "Close",
  back: "Back",
  next: "Next",
  continue: "Continue",
  done: "Done",
  confirm: "Confirm",
  edit: "Edit",
  rename: "Rename",
  copy: "Copy",
  copied: "Copied",
  copyLink: "Copy link",
  linkCopied: "Link copied",
  open: "Open",
  openInNewTab: "Open in new tab",
  retry: "Retry",
  tryAgain: "Try again",
  loading: "Loading…",
  search: "Search",
  searchPlaceholder: "Search…",
  noResults: "No results",
  learnMore: "Learn more",
  upgrade: "Upgrade",
  upgradeToPro: "Upgrade to Pro",
  settings: "Settings",
  manage: "Manage",
  enable: "Enable",
  disable: "Disable",
  on: "On",
  off: "Off",
  yes: "Yes",
  no: "No",
  or: "or",
  new: "New",
  add: "Add",
  create: "Create",
  send: "Send",
  download: "Download",
  upload: "Upload",
  share: "Share",
  connect: "Connect",
  disconnect: "Disconnect",
  connected: "Connected",
  details: "Details",
  showMore: "Show more",
  showLess: "Show less",
  more: "More",
  optional: "Optional",
  required: "Required",
  none: "None",
  unknown: "Unknown",
  somethingWentWrong: "Something went wrong. Please try again.",
  networkError: "Can't reach Mythex. Check your connection and try again.",
  justNow: "just now",
  credits: plural({ one: "{n} credit", other: "{n} credits" }),
  language: "Language",
  languageAuto: "Auto-detect",
  languageAutoHint: "Follows your browser ({language})",
  languageAutoHintDevice: "Follows your device ({language})",
  languageDescription: "The language Mythex uses for menus, buttons and messages.",
  languageChanged: "Language changed",
  /**
   * Messages the API sends with an error, by key. lib/server-messages.ts maps
   * the API's exact English text to these, so they show in the person's
   * language; keep both in step with the API routes.
   */
  server: {
    accountUnavailable: "Account unavailable.",
    storagePro: "App storage is available on the Pro plan.",
    connectedAppsDisabled: "Connected apps are not enabled on this Mythex deployment.",
    mcpUnreachable: "Could not reach that MCP server.",
    creditsEmpty: "Credit balance is empty.",
    creditsEmptySandbox: "Credit balance is empty. Buy credits or upgrade to wake a sandbox.",
    wrongPassword: "Current password is incorrect.",
    databasePro: "Databases are available on the Pro plan.",
    enableStorageFirst: "Enable storage first (storage: true).",
    passwordToDelete: "Enter your current password to delete this account.",
    exportPro: "Exporting code is available on the Pro plan.",
    previewStorageLimit: "Free Preview storage is limited to 1 GB. Upgrade to Pro for more.",
    githubTokenRejected: "GitHub rejected that token.",
    githubPro: "GitHub sync is available on the Pro plan.",
    photoTooLarge: "Max photo size is 2MB.",
    uploadTooLarge: "Max upload size is 25MB.",
    atCapacity: "Mythex is at capacity right now — try again in a moment.",
    recordNoDelete: "Mythex site records can’t be deleted.",
    recordNoEdit: "Mythex site records can’t be edited.",
    memoryNotFound: "No memory with that id.",
    storageNotConfigured: "Object storage is not configured on this Mythex instance.",
    ownerGithubOnly: "Only the project owner can link GitHub.",
    ownerOnly: "Only the workspace owner can change this.",
    photoUnavailable: "Photo upload isn't available right now.",
    verifyEmail: "Please verify your email to start building.",
    dbPausedLimit: "This app’s database is paused at its monthly limit. Raise the limit to publish.",
    dbPausedCredits: "This app’s database is paused because Cloud credits ran out. Add credits to publish.",
    dbSyncFailed: "Your app’s live database couldn’t be updated to match development, so nothing was published. Your live app and its data are unchanged.",
    dbChangesDiffer: "Your database changes are different from the ones you confirmed, so nothing was published. Publish again to review them.",
    projectNotFound: "Project not found.",
    publishPro: "Publishing is available on the Pro plan.",
    sessionOtherUser: "Session belongs to another user.",
    slugRules: "Slug must be 2–40 chars: lowercase letters, numbers, dashes.",
    stillPublishing: "Still publishing — this build is taking longer than usual.",
    memoryLooksSecret: "That looks like a password or key. Memories are not for secrets — keep those in project Secrets.",
    mcpAlreadyAdded: "That server is already added.",
    accountSuspended: "This account has been suspended.",
    domainNotRegistered: "This domain isn’t registered through Mythex. Transfer it at your current registrar.",
    projectSuspended: "This project is suspended.",
    projectUnavailable: "This project is unavailable. Contact support.",
    policyBlocked: "This request violates our Acceptable Use Policy.",
    photoType: "Use a JPEG, PNG, WebP, or GIF image.",
    googleOnly: "Your account signs in with Google.",
    workspaceWaking: "Your workspace is still waking up — try again in a moment.",
    memoryEmpty: "A memory can't be empty.",
  },
};
